const INVALID_JSON_FIELD = "InvalidJsonFieldValue";

export class RequestError extends Error {
    constructor(requestAddress, response) {
        super(
            `Request to ${requestAddress} failed with status: ${response.status}, statusText: ${response.statusText}`
        );
        this.name = "RequestError";
        this.status = response.status;
        this.statusText = response.statusText;
    }
}

export class InvalidJsonFieldValue extends Error {
    constructor(requestAddress, key) {
        super(`Request to ${requestAddress} returned invalid value for ${key}`);
        this.name = INVALID_JSON_FIELD;
    }

    static isInvalidJsonFieldError(error) {
        return (
            error && (error.name === INVALID_JSON_FIELD || error instanceof InvalidJsonFieldValue)
        );
    }
}

export const checkResponseOk = response => {
    if (response.ok) {
        return response;
    }
    throw response;
};

export const checkResponseStatus = requestAddress => response => {
    if (!response.ok) {
        throw new RequestError(requestAddress, response);
    }
    return response;
};

export const checkResponseJson = (requestAddress, key) => json => {
    if (json?.[key] === null) {
        throw new InvalidJsonFieldValue(requestAddress, key);
    } else {
        return json;
    }
};
